/**
 * Pipe text highlighter.
 * Replaces |text| patterns with styled <span> wrappers across selected elements.
 * Runs for 6 seconds after page load to catch dynamically rendered content.
 */
(function () {
  const DURATION_MS = 6000;
  const INTERVAL_MS = 100;

  const RULES = [
    { selector: ".iws-hero-body-text p", spanClass: "pipe-text" },
    {
      selector:
        ".proof-stack__feature-text.rte p, " +
        ".iws-block.iws-block-text-wrapper .iws-block-text p, " +
        ".iws-block-image-text-v2-text-content p, " +
        ".pv-icp__text p, " +
        ".iws-block-testimonial-text p",
      spanClass: "pipe-text-new",
    },
  ];

  const start = Date.now();
  const timer = setInterval(() => {
    if (Date.now() - start >= DURATION_MS) {
      clearInterval(timer);
      return;
    }

    // Base wrapping rules
    RULES.forEach(({ selector, spanClass }) => {
      document.querySelectorAll(selector).forEach((p) => {
        if (p.dataset.pipeMarked === "1") return;
        const html = p.innerHTML;
        const replaced = html.replace(/\|([\s\S]*?)\|/g, `<span class="${spanClass}">$1</span>`);
        if (replaced !== html) {
          p.innerHTML = replaced;
          p.dataset.pipeMarked = "1";
        }
      });
    });

    // Special cases inside .proof-stack__heading
    document.querySelectorAll(".proof-stack__heading p").forEach((p) => {
      if (p.dataset.pipeSpecial === "1") return;
      let html = p.innerHTML;

      html = html.replace(
        /<span class="pipe-text-new">([\s\S]*?Skyrocket[\s\S]*?T[\s\S]*?)<\/span>/g,
        '<span class="pipe-text-new-special">$1</span>'
      );
      html = html.replace(
        /<span class="pipe-text-new">([\s\S]*?Reindeer[\s\S]*?Organs[\s\S]*?)<\/span>/g,
        '<span class="pipe-text-new-special-2">$1</span>'
      );
      html = html.replace(
        /\|([\s\S]*?Skyrocket[\s\S]*?T[\s\S]*?)\|/g,
        '<span class="pipe-text-new-special">$1</span>'
      );
      html = html.replace(
        /\|([\s\S]*?Reindeer[\s\S]*?Organs[\s\S]*?)\|/g,
        '<span class="pipe-text-new-special-2">$1</span>'
      );

      if (html !== p.innerHTML) p.innerHTML = html;
      p.dataset.pipeSpecial = "1";
    });
  }, INTERVAL_MS);
})();
